module.exports = __webpack_public_path__ + "img/2icono_colaboradores.9eb3491a.svg";